export default __webpack_public_path__ + "static/media/lunch-lecture.c1d49fda.md";